import React, { useState } from 'react';
import { publicUrl } from '../utils/publicUrl';

export default function Links({ tooltip, link, imgUrl, hoverImg }) {
  const [hovering, setHovering] = useState(false);
  const isExternal = /^https?:\/\//i.test(link);

  return (
    <a
      href={link}
      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      className="link"
      data-tooltip-id="nav-tooltip"
      data-tooltip-content={tooltip}
      aria-label={tooltip}
    >
      <img
        className="link-image"
        src={publicUrl(hovering ? hoverImg : imgUrl)}
        alt=""
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      />
    </a>
  );
}
